const getters = {
    // 用户信息
    userInfo: state => {
        return state.userInfo ? state.userInfo : {
            unusedPoints: 0
        };
    },
    // 用户积分
    unusedPoints: (state, getters) => {
        return getters.userInfo.unusedPoints.toFixed(2);
    }
}
export default getters